{
  "page_intro": "すべてのカード・商品：どこで売っているか、状態、価格、持ち主。",
  "empty": "該当する商品がありません。条件を変えるか、カードを登録してください。",
  "export_shopify": "Shopify 用にダウンロード（CSV）",
  "no_photo": "画像なし",
  "cert": "鑑定番号",
  "consigned": "委託品",
  "warnings_other": "直すところ {{count}} 件",
  "condition": {
    "rank_missing": "ランク未設定",
    "sealed": "未開封",
    "rank": "ランク {{rank}}"
  },
  "status": {
    "active": "販売中",
    "draft": "下書き",
    "archived": "アーカイブ",
    "other": "その他"
  },
  "types": {
    "raw_single": "カード（素）",
    "graded_single": "鑑定済みカード",
    "sealed_product": "未開封商品",
    "supplies": "サプライ"
  },
  "filters": {
    "q": "検索",
    "q_placeholder": "名前、商品コード、鑑定番号",
    "status": "状態",
    "type": "種類",
    "rank": "ランク",
    "game": "ゲーム",
    "set": "セット",
    "set_placeholder": "セットの記号か名前（例 SV2a）",
    "price": "価格（税込）",
    "stock": "在庫",
    "consigned": "委託品",
    "has_media": "画像あり",
    "tag": "タグ",
    "price_check": "価格確認",
    "price_check_warn": "そろそろ確認（黄＋赤）",
    "price_check_alert": "確認期限切れ（赤）"
  },
  "stock": {
    "in_stock": "在庫あり",
    "sold_out": "売り切れ",
    "unknown": "未集計",
    "sold": "販売済み",
    "held": "取り置き中",
    "kinds_other": "{{count}} 種類中 {{n}} 種類在庫あり"
  },
  "price_check": {
    "today": "今日",
    "yesterday": "昨日",
    "days_ago_other": "{{count}}日前",
    "check_soon": "そろそろ確認",
    "overdue": "期限切れ — 価格を確認してください",
    "not_counted": "対象外（販売済み・アーカイブ）",
    "checked_on": "価格確認 {{date}}",
    "changed_on": "価格変更 {{date}}",
    "editor_title": "この価格のままで大丈夫ですか？",
    "editor_line": "価格確認 {{age}}（{{date}}）",
    "still_right": "この価格で問題なし",
    "still_right_saving": "保存中…",
    "save_first": "先に新しい価格を保存してください（保存すると確認したことになります）。",
    "confirmed": "価格を確認済みにしました",
    "hint": "確認しないまま{{warn}}日を過ぎると黄色、{{alert}}日を過ぎると赤になります。価格を変えても確認したことになります。"
  },
  "channels": {
    "web": "ウェブ",
    "none": "ウェブ未掲載"
  },
  "columns": {
    "image": "画像",
    "title": "名前",
    "code": "商品コード",
    "card": "ゲーム／セット／番号",
    "condition": "状態",
    "price": "価格（税込）",
    "price_check": "価格確認",
    "stock": "在庫",
    "channels": "販売先",
    "consigned": "委託者",
    "status": "状態（販売）",
    "updated": "最終更新"
  },
  "views": {
    "active": "販売中",
    "drafts": "下書き",
    "consigned_draft": "委託品・未販売",
    "sold": "売れた・発送待ち",
    "no_photos": "画像なし",
    "active_no_photos": "販売中で画像なし",
    "prices_to_check": "価格の確認が必要"
  },
  "bulk": {
    "publish": "販売する",
    "unpublish": "販売をやめる",
    "add_tag": "タグを追加",
    "tag_label": "タグ",
    "tag_add": "タグを付ける",
    "add_collection": "コレクションに追加",
    "collection_label": "コレクションを探す",
    "collections_error": "コレクションを読み込めませんでした。",
    "collections_empty": "手動のコレクションが見つかりません。",
    "price": "価格を％で変更",
    "archive": "アーカイブ",
    "channels": "マーケットプレイスへ送る",
    "channels_later": "マーケットプレイス（eBay・Whatnot など）は後のフェーズで使えます。",
    "partly": "{{ok}} 件完了、{{failed}} 件は変更できませんでした",
    "partly_hint": "「直すところ」がある商品を開いて理由を確認してください。",
    "unpublished_other": "{{count}} 件の販売をやめました",
    "published_other": "{{count}} 件を販売にしました",
    "tagged_other": "{{count}} 件にタグ「{{tag}}」を付けました",
    "collected_other": "{{count}} 件を「{{name}}」に追加しました",
    "priced_other": "{{count}} 件の価格を変更しました",
    "archived_other": "{{count}} 件をアーカイブしました",
    "archive_title_other": "{{count}} 件をアーカイブしますか？",
    "archive_consequence": "ウェブとレジから外れます。あとでアーカイブの一覧から戻せます。",
    "archive_confirm": "アーカイブする",
    "price_title": "価格を％で変更",
    "price_consequence_empty_other": "{{count}} 件の変更率を入力してください。",
    "price_consequence_up_other": "{{count}} 件の価格を {{percent}}％ 上げ、円単位（税込）に丸めます。",
    "price_consequence_down_other": "{{count}} 件の価格を {{percent}}％ 下げ、円単位（税込）に丸めます。",
    "price_percent": "変更率",
    "price_percent_hint": "{{min}}〜{{max}} の整数（例：10％ 安くするなら -10）。",
    "price_reason_placeholder": "例：相場が下がった、週末セール",
    "price_confirm_other": "{{count}} 件の価格を変更",
    "confirm_prices": "価格を確認済みにする",
    "confirm_prices_title_other": "{{count}} 枚の価格を確認済みにしますか？",
    "confirm_prices_consequence": "「価格確認」の日数が今日から数え直しになります。価格そのものは変わりません。",
    "confirm_prices_confirm": "はい、価格は正しいです",
    "prices_confirmed_other": "{{count}} 件の価格を確認済みにしました"
  },
  "row": {
    "actions": "{{title}} のその他の操作",
    "duplicated": "下書きとしてコピーしました",
    "view_on_web": "ウェブで見る",
    "view_on_web_off": "ウェブで見る（販売していません）",
    "duplicate": "コピーを作る",
    "print_label": "値札を印刷",
    "print_label_later": "レジのラベルプリンターと一緒に使えるようになります"
  },
  "detail": {
    "not_found": "この商品は存在しません（または削除されました）",
    "updated": "最終更新",
    "pictures": "画像",
    "items": "状態と価格"
  },
  "quick": {
    "title": "カードを登録",
    "intro": "4つの短いステップ・約2分。入力内容はこの端末に保存されます。",
    "progress_label": "ステップ",
    "step_of": "ステップ {{n}} / {{total}}：{{name}}",
    "steps": {
      "card": "カード",
      "condition": "状態",
      "pricing": "価格",
      "photos": "写真",
      "summary": "確認して保存"
    },
    "headings": {
      "card": "どのカードですか？",
      "condition": "状態はどうですか？",
      "pricing": "価格・数量・保管場所",
      "photos": "写真を撮る・追加する"
    },
    "next": "次へ",
    "back": "戻る",
    "publish": "すぐに販売する",
    "save_draft": "下書き保存",
    "card": {
      "label": "どのカード？",
      "change": "別のカードを選ぶ",
      "not_a_card": "1枚のカードではなく、未開封のBOX・パック",
      "free_title": "商品名",
      "free_title_hint": "例：ポケモンカード 151 BOX（日本語版）",
      "back_to_list": "やっぱりカード — カード一覧から選ぶ",
      "cert_kept": "鑑定番号 {{cert}} を控えました — どのカードか選んでください。"
    },
    "condition": {
      "kind": "何ですか？",
      "raw_single": "カード",
      "raw_single_hint": "通常のカード — Rank を選ぶ",
      "graded_single": "鑑定品",
      "graded_single_hint": "ケース入り（PSA・BGS・CGC など）",
      "sealed_product": "未開封",
      "sealed_product_hint": "開けていない BOX・パック",
      "rank_note": "状態のひとこと（任意）",
      "rank_note_hint": "例：裏面に小さな傷。お客様に表示されます。",
      "quantity": "数量",
      "weight": "重さ（箱ごと・g）",
      "weight_hint": "送料の計算に使います — 箱ごと量ってください",
      "box": "箱の状態（任意）",
      "box_hint": "例：シュリンク付き、角に小さなへこみ"
    },
    "graded": {
      "company": "鑑定会社",
      "grade": "グレード",
      "psa_whole": "PSA は整数のグレードのみ",
      "other": "その他",
      "label": "ケースのラベル",
      "label_hint": "自動で入ります — ケースと違えば直してください",
      "cert": "鑑定番号",
      "cert_hint": "ラベルの番号（バーコードをスキャンできます）",
      "cert_format": "{{company}} の通常の番号と形が違います — 確認してください（保存はできます）。",
      "checking": "確認中…",
      "cert_taken": "この鑑定品はすでに登録されています：{{title}}",
      "open_existing": "開く"
    },
    "pricing": {
      "price": "販売価格",
      "cost": "仕入・買取価格（任意）",
      "cost_hint": "スタッフだけに表示 — 利益の計算に使います",
      "tax_note": "税込の価格を入れてください。税抜価格と消費税 10% は保存時にシステムが計算して表示します。",
      "below_cost": "仕入価格より安くなっています。問題なければそのままで大丈夫です。",
      "compare_at_on": "参考価格（通常価格・定価）を表示する",
      "keihyo": "景品表示法により、参考価格には根拠が必要です。根拠がないとお客様には表示されません。",
      "compare_at": "参考価格",
      "evidence": "参考価格の根拠は？",
      "evidence_own_price_history": "お店が実際にこの価格で販売していた",
      "evidence_own_price_history_hint": "システムが価格の履歴を確認します（直近8週間で十分な期間その価格だったこと）。",
      "evidence_market_survey": "市場価格の調査",
      "evidence_market_survey_hint": "どう比べたか・いつ調べたかを書きます。",
      "evidence_msrp": "メーカー希望小売価格",
      "evidence_msrp_hint": "未開封品のみ — メーカーのページと日付を入れます。",
      "evidence_url": "根拠のウェブページ",
      "evidence_date": "確認した日",
      "evidence_method": "価格の比べ方",
      "quantity": "数量",
      "quantity_locked": "1点もののカード — 常に 1",
      "location": "保管場所"
    },
    "consignor": {
      "consigned": "このカードは委託品です",
      "label": "誰のカードですか？",
      "placeholder": "名前または CON- 番号",
      "results": "委託者",
      "verified": "本人確認済み",
      "not_verified": "本人確認がまだです",
      "status": {
        "pending_verification": "本人確認待ち",
        "suspended": "一時停止中",
        "closed": "終了"
      },
      "choose": "選ぶ",
      "fix": "先に確認する",
      "change": "変更",
      "error": "委託者を読み込めませんでした。",
      "agreed": "委託者と決めた最低価格（任意）",
      "agreed_hint": "これより下げるときは委託者に確認します",
      "commission": "お店の手数料（任意）",
      "commission_hint": "空欄 = いつもの手数料",
      "discount": "値引き OK（最大 {{max}}%）"
    },
    "photos": {
      "label": "カードの写真",
      "hint": "スマホのカメラで撮るかファイルを選びます。販売するには写真が1枚以上必要です。下書きは写真なしで保存できます。",
      "wait": "写真をアップロード中です — 少しお待ちください。"
    },
    "summary": {
      "title": "お店での商品名",
      "title_auto": "カードから自動で作りました — 変えても大丈夫です",
      "title_own": "自分で決めた商品名",
      "card": "カード",
      "condition": "状態",
      "price": "価格",
      "stock": "在庫",
      "photos": "写真",
      "change": "{{what}}を変更",
      "tax_after": "税抜価格と消費税は保存後に表示されます（システムが計算）。",
      "compare_at": "参考価格 {{price}}",
      "cost": "仕入 {{price}}",
      "stock_at_other": "{{where}} に {{count}} 点",
      "consigned": "委託品 — {{name}}",
      "photo_count_other": "写真 {{count}} 枚",
      "no_photos": "写真がまだありません（販売には必要）"
    },
    "problems": {
      "card_required": "カードを選んでください（または「未開封」）",
      "title_required": "商品名を入れてください",
      "rank_required": "カードの状態 A〜D を選んでください",
      "company_required": "鑑定会社を選んでください",
      "grade_required": "グレードを選んでください",
      "cert_required": "鑑定番号を入れてください",
      "cert_taken": "この鑑定番号はすでに登録されています",
      "quantity_invalid": "1以上の整数で入れてください",
      "weight_required": "重さをグラムで入力してください（1以上）",
      "price_required": "価格を円で入れてください（1以上）",
      "compare_at_required": "参考価格を入れてください",
      "compare_at_not_higher": "参考価格は販売価格より高くしてください",
      "evidence_required": "参考価格の根拠を選んでください",
      "evidence_url_required": "根拠のウェブページを入れてください",
      "evidence_date_required": "日付を入れてください",
      "evidence_method_required": "価格の比べ方を書いてください",
      "msrp_cards": "カードにはメーカー希望小売価格がありません — 別の根拠を選んでください",
      "location_required": "保管場所を選んでください",
      "consignor_required": "委託者を選んでください",
      "commission_invalid": "0〜100 の数字で入れてください",
      "photo_required": "販売するには写真を1枚以上追加してください（または下書き保存）"
    },
    "done": {
      "title": "保存しました",
      "price": "価格（税込）",
      "excl": "税抜",
      "tax": "消費税 {{rate}}%",
      "toast_listed": "「{{title}}」を販売開始しました",
      "toast_draft": "「{{title}}」を下書き保存しました",
      "not_listed": "在庫と一緒に保存しましたが、まだ販売していません：",
      "publish_problem": "足りないものがあります — カードを開いて確認してください",
      "next": "次のカードを登録",
      "same": "同じカードをもう1枚（番号・価格・写真を変える）",
      "open": "カードを開く"
    },
    "failure": {
      "nothing_saved": "まだ何も保存されていません。",
      "product_after_save": "まだ何も保存されていません。",
      "stock_after_save": "カードは下書き保存されましたが、在庫がまだ登録されていません。「もう一度」を押してください — 二重にはなりません。",
      "intake_after_save": "委託の受付は記録されましたが、カードの準備がまだです。「もう一度」を押してください。",
      "publish_after_save": "カードと在庫は保存されましたが、販売を開始できませんでした。",
      "load_after_save": "保存しました — 結果を表示できませんでした。カードを開いてください。",
      "retry": "もう一度",
      "open": "保存したカードを開く"
    }
  },
  "edit": {
    "jump": "移動",
    "short": {
      "1": "カード",
      "2": "商品名",
      "3": "状態",
      "4": "価格",
      "5": "カテゴリ",
      "6": "写真",
      "7": "詳細",
      "8": "委託",
      "9": "販売先",
      "10": "検索・状態"
    },
    "sections": {
      "card": "カード",
      "title": "商品名と説明",
      "condition": "状態",
      "pricing": "価格と在庫",
      "tags": "カテゴリとタグ",
      "media": "写真",
      "details": "詳細",
      "consignment": "委託",
      "channels": "販売先",
      "seo": "検索エンジンと状態"
    },
    "hints": {
      "card": "この商品がカード図鑑のどのカードか。",
      "media": "1枚目がメインの写真です。ドラッグで順番を変えられます。"
    },
    "change_card": "カードを変更",
    "keep_card": "今のカードのまま",
    "no_card": "カード図鑑のカードとつながっていません。",
    "title": "商品名",
    "title_required": "商品名は空にできません",
    "description": "説明",
    "description_hint": "空行で段落を分けます。",
    "languages": "ほかの言語の商品名と説明",
    "rank_note": "状態のひとこと",
    "saved_price": "保存中の価格：",
    "excl": "税抜",
    "tax": "消費税 {{rate}}%",
    "compare_at_verified": "参考価格 確認済み",
    "compare_at_unverified": "参考価格は非表示（根拠がまだない）",
    "single_stock": "1点もののカード：店にある間は在庫 1 です。",
    "stock_hint": "在庫は「在庫」画面で変更します（入荷・理由つきの調整）。",
    "open_stock": "在庫を開く",
    "category": "カテゴリ",
    "no_category": "カテゴリなし",
    "vendor": "メーカー",
    "tags": "タグ",
    "tags_hint": "カンマ区切り（例：SAR, 151）",
    "collections": "手で選ぶコレクション",
    "no_collections": "手で選ぶコレクションはまだありません",
    "smart_matches": "条件で入っている：",
    "read_only": "写真は見るだけで変更できません。",
    "detail_text": "商品についての詳しい説明",
    "detail_text_hint": "商品ページの説明の下に表示されます",
    "consigned": "このカードは委託品です。",
    "open_consignment": "委託品を開く",
    "shop_own": "お店の商品です。",
    "channel_web": "ウェブショップ",
    "channel_pos": "店頭レジ（POS）",
    "layout": "ページのレイアウト",
    "layout_hint": "標準のままなら空欄",
    "status": "状態",
    "publish_at": "あとで販売開始（日本時間）",
    "publish_at_hint": "空欄なら下書きのまま",
    "trash": "ゴミ箱へ移動",
    "trash_title": "この商品をゴミ箱へ移動しますか？",
    "trash_body": "お店から取り下げます。在庫と履歴は残ります。30日以内なら元に戻せます。",
    "trashed": "ゴミ箱へ移動しました",
    "in_trash": "この商品はゴミ箱にあります。",
    "save": "保存",
    "saved": "保存しました",
    "nothing_changed": "変更はありません",
    "fix_first": "赤い印の部分を先に直してください",
    "rank_confirm_title": "販売中のカードの Rank を変えますか？",
    "rank_confirm_body": "お客様にはすぐ新しい Rank が表示されます。理由を書いてください（履歴に残ります）。",
    "rank_confirm": "Rank を変更",
    "side_label": "この商品のまとめ",
    "side": {
      "status": "現在",
      "stock": "店舗ごとの在庫",
      "stock_error": "在庫を読み込めませんでした",
      "no_stock": "在庫の記録がありません",
      "available": "{{onHand}} 点中 {{available}} 点が販売可",
      "receive": "入荷する",
      "price_history": "価格の履歴",
      "no_history": "まだ変更はありません",
      "changes": "最近の変更",
      "no_changes": "変更の記録はありません",
      "all_history": "履歴をすべて見る"
    }
  },
  "translations": {
    "tabs": "言語",
    "locale": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh-Hant": "繁體中文",
      "zh-Hans": "简体中文"
    },
    "copy_all": "英語をすべての言語にコピー",
    "copy_one": "英語からコピー",
    "mark_checked": "確認しました",
    "suggest": "翻訳の候補を出す",
    "empty_badge": "空",
    "unchecked_badge": "要確認",
    "copied_mark": "英語からコピー — まだ確認していません",
    "still_empty": "まだ空です",
    "en_hint": "英語が元の文章です — ほかの言語が空のときは英語が表示されます。",
    "unchecked_count_other": "コピーしたまま未確認の文章が {{count}} 件"
  },
  "seo": {
    "heading": "検索エンジン",
    "preview": "Google での見え方",
    "title": "Google のタイトル",
    "description": "Google の説明",
    "count": "{{count}} / {{max}}",
    "address": "ウェブアドレス",
    "address_changed": "古いリンクもそのまま使えます — 新しいアドレスに移動します。"
  },
  "variants": {
    "name": "種類（例：BOX / パック）",
    "name_n": "種類 {{n}} の名前",
    "price": "価格（税込）",
    "price_n": "種類 {{n}} の価格",
    "cost": "仕入",
    "cost_n": "種類 {{n}} の仕入価格",
    "barcode": "バーコード（JAN）",
    "barcode_n": "種類 {{n}} のバーコード",
    "weight": "重さ（g）",
    "weight_n": "種類 {{n}} の重さ",
    "remove": "消す",
    "remove_n": "種類 {{n}} を消す",
    "add": "種類を追加",
    "excl": "税抜"
  },
  "attributes": {
    "list_hint": "1行に1つ",
    "reference_hint": "つながっているもののコード",
    "structured_hint": "上級者向け — 変更前にオーナーに確認してください",
    "problems": {
      "required": "入力してください",
      "not_integer": "整数で入れてください",
      "not_number": "数字で入れてください",
      "below_min": "{{min}} 以上",
      "above_max": "{{max}} 以下",
      "too_long": "{{maxLength}} 文字まで",
      "regex_mismatch": "形式が合いません",
      "not_in_choices": "選択肢から選んでください",
      "not_url": "ウェブアドレス（https://…）を入れてください",
      "not_date": "日付を選んでください",
      "not_structured": "決められた形になっていません",
      "too_many_items": "{{maxItems}} 個まで"
    }
  },
  "trash": {
    "title": "ゴミ箱",
    "intro": "過去 {{days}} 日に削除した商品です。元に戻すとまた使えます — 在庫と履歴は残っています。",
    "empty": "ゴミ箱は空です",
    "days_left_other": "残り {{count}} 日",
    "restore": "元に戻す",
    "restored": "「{{title}}」を下書きとして戻しました"
  },
  "publish_issues": {
    "title_missing": "商品名がありません",
    "price_missing": "価格がありません",
    "raw_rank_missing": "Rank（A〜D）がありません",
    "cert_missing": "鑑定番号がありません",
    "category_missing": "カテゴリがありません",
    "no_variant": "価格の行がありません",
    "compare_at_unverified": "参考価格の根拠がまだありません",
    "translation_ja_missing": "日本語の商品名がありません",
    "other": "足りないものがあります（{{field}}）"
  }
}
